// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { getPluginManager } from "../core/plugin";
      import { __getRoot } from "../exports"
      import { microApp,getGlobalShareConfigValueByKey } from "@spiral-app/core";
      import {
        Sentry,
        SentryConfigKit,
        SPIRAL_APP_VERSION,
        DEFAULT_SPIRAL_APP_THEME,
        useAppStore,
        useMicroAppStore,
        MicroAppConfigType,
        ConfigOptionsProps,
        MicroAppEventData,
        MicroAppEventMessage,
        MicroAppEventType,
      } from "@spiral-app/core";
      import { ConfigProvider } from "antd";


      // 子应用basename设置
      // export const modifyClientRenderOpts = (ctx: any) => {
      //   const isTabsMode = getGlobalShareConfigValueByKey("tabsMode");
      //   const basename = (window as any)["__MICRO_APP_BASE_ROUTE__"];
      //   if(basename && !isTabsMode){
      //     ctx.basename = basename;
      //   }
      //   return ctx;
      // };

      export const rootContainer = (container) => {

        // 用户自己设置的rootContainer会包裹这个rootContainer,先运行用户自定义的，再运行这个rootContainer，所以要注意运行顺序
        const runtimeConfig = getPluginManager().applyPlugins({
          key: "spiral",
          type: "modify",
        });

        // 初始化微应用列表
        const microApps = process.env.SPIRAL_MICRO_APPS as
          | MicroAppConfigType[]
        useMicroAppStore.getState().initMicroApps(microApps || [],{
          forceClearHomeCache: runtimeConfig?.microAppInitConfig?.forceClearHomeCache || false,
        });

        if (!window.__MICRO_APP_ENVIRONMENT__ && !microApp.hasInit) {
          microApp.start({
            ...(runtimeConfig?.microAppInitConfig||{}),
            lifeCycles: {
              created(e) {
                useMicroAppStore.getState().setStatus(e.detail.name, "created");
              },
              beforemount(e) {
                useMicroAppStore.getState().setStatus(e.detail.name, "beforemount");
              },
              mounted(e) {
                useMicroAppStore.getState().setStatus(e.detail.name, "mounted");
              },
              unmount(e) {
                useMicroAppStore.getState().setStatus(e.detail.name, "unmount");
              },
              error(e) {
                microApp.unmountApp(e.detail.name);
                useMicroAppStore.getState().setStatus(e.detail.name, "error");
              },
            },
          });
        }

        const runtimeMonitorOptions = runtimeConfig?.monitor || {};
        const envConfig = process.env.MONITOR_CONFIG as
          | ConfigOptionsProps
          | undefined;

        const monitorConfig = {
          ...envConfig,
          ...runtimeMonitorOptions,
        };

        if (envConfig && monitorConfig.name && monitorConfig.dsn) {
          const runtimeOptions = runtimeMonitorOptions?.runtimeOptions;
          const sentryConfig = {
            ...(new SentryConfigKit(monitorConfig)),
            ...runtimeOptions
          };
          useAppStore.setState({
            monitorConfig: sentryConfig,
          });
          if (runtimeOptions?.runInDev || sentryConfig.canIWatch()) {
            // 子应用不启用sentry
            if (!window["__MICRO_APP_ENVIRONMENT__"]) {
              const { init, BrowserTracing } = Sentry;
              const options = {
                dsn: sentryConfig.options.dsn,
                integrations: runtimeOptions?.integrations || [new BrowserTracing()],
                environment: sentryConfig.options.environment,
                release: sentryConfig.options.release,
                tracesSampleRate: runtimeOptions?.tracesSampleRate || 1.0,
                transport: sentryConfig.customTransport,
                ignoreErrors: [
                  ...sentryConfig.DEFAULT_IGNORE_ERRORS,
                  ...(runtimeOptions?.ignoreErrors || []),
                ],
              };
              // sentry监控
              init(options);
            }
          }
        }
        window.localStorage.setItem(
          process.env.APP_NAME! + process.env.APP_VERSION! + "_SPIRAL_APP_VERSION",
          SPIRAL_APP_VERSION
        );

      // 主应用发起unmount前，进行自卸载
      if(window.microApp){
        window.microApp.addDataListener(
    (msg: MicroAppEventMessage<MicroAppEventType>) => {
      const data = msg.data as MicroAppEventData["setAppStatus"];
      if (data === "unmount") {
        __getRoot()?.unmount();
      }
    },
  );
        //子应用卸载
    window.unmount = () => {
        __getRoot()?.unmount();
    };
  }
        return container
      };
